import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from "react-router";
import BlogDirectory from "./directory/BlogDirectory";
import BlogPostWrapper from "./blog-post/BlogPostWrapper";
import { BlogProvider } from "./context/BlogContext";
const BlogWrapper = () => {
    return (_jsx(BlogProvider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "", element: _jsx(BlogDirectory, {}) }), _jsx(Route, { path: ":page_slug", element: _jsx(BlogPostWrapper, {}) })] }) }));
};
export default BlogWrapper;
